import React from 'react';

import {DisclaimerResults} from '../../typing/main';
import {hasBeforeResults, modalsData} from '../../store/local-storage';
import {onVWBasicVehicleButtonClick} from '../../tagging/tagging-helpers';
import {SearchNoResultsSection} from '../search-no-results-section';
import {StyledResultsSectionContainer, StyledResultWrapper} from './styles';
import {UsedInventoryData, UsedVehicle} from '../../typing/used-inventory';
import {useHistory} from '../../hooks/use-history';
import {useTrackingManager} from '../../hooks/use-tracking-manager';
import SearchResultsVehicleCard from '../search-results-vehicle-card';
import {ModalDisplayMode} from '../../typing/modal-display';

interface SearchResultsSectionProps {
  currentSearchData?: UsedInventoryData;
  disclaimers: DisclaimerResults[];
  onHandleContactDealer: () => void;
}

const SearchResultsSection: React.FC<SearchResultsSectionProps> = ({
  currentSearchData,
  disclaimers,
  onHandleContactDealer,
}) => {
  const history = useHistory();
  const trackingManager = useTrackingManager();
  const vehicles = currentSearchData?.vehicles || [];
  const priceDisclaimer = disclaimers.find(
    disclaimer => disclaimer.token === 'price',
  );
  const warrantyDisclaimers = disclaimers.filter(
    disclaimer => disclaimer.token === 'warranty',
  );

  const getWarrantyDisclaimerNumber = (year?: string, model?: string) => {
    if (!year) return;

    let number: string = '';

    warrantyDisclaimers.forEach((disclaimer: DisclaimerResults) => {
      // Check if the year matches
      const yearMatches = disclaimer.includes.includes(year);
      // Check if the disclaimer is for a specific model OR applies to all models
      const modelMatches = !disclaimer.model || disclaimer.model === model;

      if (yearMatches && modelMatches) number = disclaimer.number || '';
    });

    return number;
  };

  const onHandleRedirectVehicle = (vehicle: UsedVehicle) => {
    hasBeforeResults(true);
    const href = `/cpo/vehicle/${vehicle.vin}`;
    history.push(href);
    const filter = {url: window.location.href, name: 'Vehicle Details'};
    onVWBasicVehicleButtonClick(vehicle, filter, trackingManager);
  };

  if (!vehicles?.length)
    return (
      <SearchNoResultsSection
        closestDealer={currentSearchData?.closestDealer}
        onHandleDealerContact={onHandleContactDealer}
        priceDisclaimer={priceDisclaimer?.number}
        getWarrantyDisclaimer={getWarrantyDisclaimerNumber}
      />
    );

  const generateKey = pre => {
    return `${pre}_${new Date().getTime()}`;
  };

  const onHandleBuyingTransition = (
    vehicle: UsedVehicle,
    vehiclePosition: number,
  ) => {
    const filter = {url: window.location.href, name: 'Build my Deal'};
    onVWBasicVehicleButtonClick(vehicle, filter, trackingManager);
    modalsData({
      vehicle,
      active: true,
      mode: ModalDisplayMode.HANDOFF_BUYING,
      vehiclePosition,
    });
  };

  return (
    <StyledResultsSectionContainer className="results-section_main-container">
      {vehicles.map((vehicle: UsedVehicle, index: number) => (
        <StyledResultWrapper
          className="results-section_card-item"
          key={generateKey(vehicle.vin)}
        >
          <SearchResultsVehicleCard
            vehicle={vehicle}
            onHandleVehicleClick={onHandleRedirectVehicle.bind(null, vehicle)}
            priceDisclaimer={priceDisclaimer?.number}
            warrantyDisclaimer={getWarrantyDisclaimerNumber(
              vehicle.modelYear,
              vehicle.model,
            )}
            startBuyingHandler={onHandleBuyingTransition.bind(
              null,
              vehicle,
              index + 1,
            )}
          />
        </StyledResultWrapper>
      ))}
    </StyledResultsSectionContainer>
  );
};

export default SearchResultsSection;
